import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import Header from './components/Header.js'


ReactDOM.render(<App />,
  document.getElementById('root')
);
